<form #theForm="ngForm" name="trackingField" (ngSubmit)="ok()" [formGroup]="formData" novalidate>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Configuration key</h4>
  </div>

  <div class="form-group modal-body">
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label title="Enter a key name for your configuration key. This is also the key name you use to access the value from a map or other components">Key Name</label> *
            <input formControlName="name" class="form-control" ngbAutofocus required />
            <div [class.invisible]="!formData.get('name').hasError('required') || formData.get('name').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label title="Choose where you wish the configuration key to appear. If the value should be presented on the partners configuration key tab, or on the distribution">Usage</label> *
            <select class="form-control" formControlName="usageId">
              @for (item of usages; track item) {
                <option [title]="getUsageTooltip(item.KeyUsageName).tooltip" [ngValue]="item.KeyUsageId">
                  {{getUsageTooltip(item.KeyUsageName).name}}
                </option>
              }
            </select>
            <div [class.invisible]="!formData.get('usageId').hasError('min') || formData.get('usageId').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div [hidden]="usageType() !== 'DistributionObject'" class="col-md-6 col-md-offset-6">
          <div class="form-group">
            <label>Distribution Object</label>
            <div class="row">
              <div class="col-sm-12">
                <ep-distribution-object-selector #distributionObjectSelector
                  [selectedDistributionObject]="selectedDistributionObject"
                  (selectedDistributionObjectChange)="selectedDistributionObject = $event">
                </ep-distribution-object-selector>
              </div>
            </div>
          </div>
        </div>
        <div [hidden]="usageType() !== 'Partner'" class="col-md-6 col-md-offset-6">
          <div class="form-group">
            <label title="Which document partner should this configuration key be associated with? This will limit the key to only be presented on this partner">Partner</label>
            <ep-partner-selector id="partnerId" [(selectedPartner)]="partner">
            </ep-partner-selector>
          </div>
        </div>
        <div [hidden]="usageType() !== 'DocumentConfig'" class="col-md-6 col-md-offset-6">
          <div class="form-group">
            <label title="Which document configuration should this configuration key be associated with? This will limit the key to only be presented when this specific document configuration is picked on the distribution">Document Config</label>
            <select class="form-control ng-valid ng-dirty ng-touched" formControlName="documentConfig">
              <option [value]="null">Select...</option>
              @for (item of documentConfigList; track item) {
                <option [ngValue]="item.DocumentConfigId">
                  {{item.DistributionObjectName}} / {{item.Direction}} / {{item.FormatName}} / {{item.VariantName}} / {{item.VersionName}}
                </option>
              }
            </select>
          </div>
        </div>

        <div [hidden]="usageType() !== 'FormatType'" class="col-md-6 col-md-offset-6">
          <div class="form-group">
            <label title="Which format type should this configuration key be associated with? This will limit the configuration to only appear when a document configuration with this specific format type is choosen on the distribution">Format Type</label>
            <select class="form-control ng-valid ng-dirty ng-touched" formControlName="formatType">
              <option [value]="null">Select...</option>
              @for (item of formatTypes; track item) {
                <option [ngValue]="item.Id">
                  {{item.Name}}
                </option>
              }
            </select>
          </div>
        </div>
      </div>

      <app-developer-data-field formControlName="dataField"
        [dataFieldGroups]="dataFieldGroups"
        [dataFieldTypes]="dataFieldTypes"
        groupTooltip = "Grouping of configuration keys displayed in the partner configuration keys tab."
        typeTooltip = "Data type of the configuration key (e.g., Textbox, Chekbox, or Dropdown). This will indicate how the field is presented in the UI."
        displayNameTooltip = "Label name of the configuration key."
        isRequiredTooltip = "If checked this field will be required when updating a partner or distribution with this field"
        dataLengthTooltip = "Maximum length of the configuration key value. This is used for UI input validation"
        regexTooltip = "Type in a regex if the input should match a specific patterns. Could be for a date in format YYYY-MM-DD that can be expressed with this reges: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$"
        regexTextTooltip = "The error text to indicate the regex requirement. E.g. in the above the input value must match a date in the format YYYY-MM-DD"
        infoTextTooltip = "Tooltip text displayed when hovering over the configuration key displayed"
        defaultValueTooltip = "Value to be pre-filled when creating a new partner or distribution with this field"
        sortOrderTooltip ="Order of the configuration key within the group"
        source ="configurationKey">
      </app-developer-data-field>
    </div>
  </div>

  <div class="modal-footer">
    <div class="text-center">
      <button type="submit" style="min-width: 12rem;" class="btn btn-primary" [disabled]="formData.invalid">OK</button>
      <button type="button" style="min-width: 12rem;" class="btn btn-default" (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
